import { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  Popover,
  PopoverBody
} from 'reactstrap';
import IcNotification from 'assets/svg/ic_notification.svg';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import notificationActions from 'store/notification/actions';
import notificationSelectors from 'store/notification/selectors';
import { getDataCookie } from 'common';
import NotificationPanel from './NotificationPanel';


export const PAGE_SIZE_DEFAULT = 20;

export default function NotificationButton() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const unreadCount = useAppSelector(notificationSelectors?.unreadCount);
  // REACT_APP_COOKIE_KEY is always defined at build time (mirrors common.ts's own usage of `!` on env keys).
  const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY!)
  
  const toggle = () => setOpen(!open);
  
  useEffect(() => {
    dispatch(notificationActions.getNotifications.fetch({
      page: 0,
      size: PAGE_SIZE_DEFAULT,
      staffId: staffId
    }));
    dispatch(notificationActions.countNotificationUnread.fetch({staffId}));
  },[]);

  return (
    <>
      <div
        role="button"
        id="notificationBtn"
        onClick={toggle}
        style={{ position: 'relative' }}
      >
        <img src={IcNotification} alt="notification" className="w-6 h-6" />

        <span className="text-xs text-white bg-red rounded-full"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '100%',
            width: 20,
            height: 20,
            position: 'absolute',
            top: -6,
            right: -7,
          }}>
          {unreadCount?.unreadCount ?? 0}
        </span>
      </div>

      <Popover
        placement="bottom-start"
        isOpen={open}
        target="notificationBtn"
        toggle={toggle}
        trigger="legacy"
        style={{ borderRadius: 8 }}
      >
        <PopoverBody className="bg-white p-0" >
          <NotificationPanel />
        </PopoverBody>
      </Popover>
    </>
  );
}